import { Builder } from '@builder.io/react'
import { LinkButtonRegisterProps } from 'components/ui-builder/common/button'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { HeadingClass, HeadingType } from 'enums'
import { navigate } from 'gatsby'
import React from 'react'
import { LinkButtonProp } from '../common/button'
import CustomHeading, { headingTypePropObj, headingClassPropObj } from '../common/heading'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}
interface Props {
  backgroundImage: any
  backgroundImageMobile: any
  backgroundColor: string
  // cloudinaryImage: any
  builderImage: any
  cloudinaryImageAltText: string
  headingText: string
  headingTextColor: string
  contentText: string
  headingType: HeadingType
  headingClass: HeadingClass
  textAlignment: Alignment
  buttonEnabled: boolean
  buttonProp: LinkButtonProp
}
const BannerAlternate = ({
  backgroundImage = '',
  backgroundImageMobile,
  backgroundColor,
  // cloudinaryImage,
  builderImage,
  cloudinaryImageAltText = '',
  headingText,
  headingTextColor,
  contentText,
  headingType,
  headingClass,
  textAlignment,
  buttonEnabled,
  buttonProp
}: Props) => {
  const _getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const _renderCTAButton = () => {
    if (!buttonEnabled) {
      return (
        <button
          className={`mx-auto flex w-10/12 items-center justify-center rounded-full border border-transparent bg-[#006685] px-5 py-3 text-base font-medium text-white md:mt-8 md:w-96 md:text-lg lg:my-16 lg:w-3/5`}
          onClick={() => {
            if (typeof window.gtag !== 'undefined') {
              window.gtag('event', 'cta_component_dog_hero_treat_cta_logged_in', {
                page: 'home_page'
              })
            }
            navigate('#')
          }}
        >
          {`${buttonProp?.buttonText}`}
        </button>
      )
    }

    return null
  }

  const renderImage = () => {
    if (builderImage) {
      return (
        <div>
          {' '}
          <CdnImage
            className="block h-28 w-28 object-contain lg:h-40 lg:w-40"
            url={builderImage}
            alt={cloudinaryImageAltText}
            steps={[705]}
            style={{
              maxHeight: '100%',
              maxWidth: '100%'
            }}
          />
          {/* {builderImage ? (
            <CdnImage
              className="block h-28 w-28 object-contain lg:h-40 lg:w-40"
              url={builderImage}
              alt={cloudinaryImageAltText}
              steps={[705]}
              style={{
                maxHeight: '100%',
                maxWidth: '100%'
              }}
            />
          ) : (
            <CloudinaryImage
              className="block h-28 w-28 object-contain lg:h-40 lg:w-40"
              publicId={cloudinaryImage?.public_id}
              alt={cloudinaryImageAltText}
              steps={[705]}
              style={{
                maxHeight: '100%',
                maxWidth: '100%'
              }}
            />
          // )} */}
        </div>
      )
    }
    return null
  }

  const getContent = () => {
    return (
      <>
        {renderImage()}

        <div className="z-10 relative flex w-full lg:w-4/5 flex-col justify-center items-center -mt-4 mb-6 lg:mt-0 lg:mb-0">
          <div className="w-full">
            {' '}
            <CustomHeading
              classList="line-height-fix w-full h-full tracking-tight text-gray-900 text-left font-medium text-center mt-8 lg:m-4"
              headingClass={headingClass}
              headingType={headingType}
              color={headingTextColor}
            >
              {headingText}
            </CustomHeading>
          </div>
          {/* <div>
            <p
              className={`enable-list-styles mt-4 h-full text-center text-base font-medium font-sans w-full ${getAlignmentClass()}`}
              dangerouslySetInnerHTML={{ __html: contentText }}
            ></p>{' '}
          </div> */}
          <button
            className={`mb-6 mt-2 flex w-1/2 lg:w-1/3 items-center justify-center rounded-full border border-transparent bg-[#006685] px-2 py-2 text-base font-medium text-white`}
            onClick={() => {
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', 'cta_component_go_to_account_cta_logged_in', {
                  page: 'home_page_logged_in'
                })
              }
              navigate(`${buttonProp?.buttonUrl}`)
            }}
          >
            {`${buttonProp?.buttonText}`}
          </button>
        </div>
      </>
    )
  }
  return (
    <a href={buttonProp.buttonUrl} style={{ display: 'block', textDecoration: 'none' }}>
      <div
        className="relative mx-auto my-2 flex-col items-center justify-center bg-white w-4/5 bg-100% rounded-2xl hidden md:flex"
        style={{
          backgroundColor,
          backgroundImage: backgroundImage ? `url(${backgroundImage ?? ''})` : 'none',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '12rem'
        }}
      >
        {getContent()}
      </div>
      <div className="relative mx-auto my-0 flex flex-col items-center justify-center bg-white bg-auto w-11/12 rounded-2xl md:hidden">
        <div className="index-0 -mb-32">
          <img
            className="w-full"
            src={backgroundImageMobile}
            style={{
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '10rem'
            }}
          />
        </div>

        {getContent()}
      </div>
    </a>
  )
}
export default BannerAlternate
Builder.registerComponent(BannerAlternate, {
  name: 'BannerAlternate',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'backgroundImageMobile',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    // {
    //   name: 'cloudinaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'cloudinaryImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    }
  ]
})
